import React from 'react';

interface Props {
    activeColor:string
}
const DropdownIcon = (props:Props) => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3575 15.9375L19.7275 9.56746C20.2 9.09496 20.0425 8.70996 19.3725 8.70996H5.62751C4.95751 8.70996 4.80001 9.09246 5.27251 9.56746L11.6425 15.9375C12.1175 16.41 12.8825 16.41 13.3575 15.9375Z" fill={props.activeColor}/>
        </svg>
    );
};

export default DropdownIcon;